// Style container của các trang /mobile/*: phủ toàn màn hình, đè lên navbar.
// Bắt buộc position: fixed. app.vue bọc router-view trong một div không có chiều cao, nên
// height: 100% mà không fixed sẽ ra 0px: Leaflet vẫn tạo bản đồ, không báo lỗi gì, nhưng trang
// trắng trơn (a17adbe từng xoá dòng này khỏi Map2DViewer).
export function mobileFullScreenStyle() {
  return {
    position: 'fixed',
    height: '100%',
    width: '100%',
    top: 0,
    left: 0,
    'z-index': 9999,
  };
}
